var render = function render(){var _vm=this,_c=_vm._self._c;return _c('e-svg-icon',{attrs:{"name":_vm.item.notify ? 'notification-filled' : 'notification-crossed-outline'}})
}
var staticRenderFns = []

export { render, staticRenderFns }